import {SET_NAV_REVIEWS_PARAMS, SET_REVIEWS_LIST} from "./constans";
import {objectsApi} from "../../API/API";



export const setReviewList = (payload) => {
    return {
        type: SET_REVIEWS_LIST,
        payload
    }
}


export const setNavReviewParams = (payload) => {
    return {
        type: SET_NAV_REVIEWS_PARAMS,
        payload
    }
}


export const setReviewListFromCache = (review) => async (dispatch) => {
    await dispatch(setReviewList(review))
}

export const setReviewNavParamsFromCache = (navParams) => async (dispatch) => {
    await dispatch(setNavReviewParams(navParams))
}


export const getReviewList = (params) => async (dispatch) => {
    let response = await objectsApi.getReviewsList(params);

    if (response.status) {
        return dispatch(setReviewList(response.data))
    }
}


export const getNavReviewParams = (params) => async (dispatch) => {
    let response = await objectsApi.getReviewsNavParams(params);

    if (response.status) {
        dispatch(setNavReviewParams(response.data))
    }
}
